import React from 'react';

import CommonModal from '../../components/common-modal/CommonModal.component';

import './WatchVideoModal.component.scss';

export const WATCH_VIDEO_DEFAULT_EMBED_URL = 'https://player.vimeo.com/video/1193046384?badge=0&autopause=0&player_id=0&app_id=58479';


function WatchVideoModal({
    isOpen,
    onClose,
    title = 'Found in London',
    embedUrl = WATCH_VIDEO_DEFAULT_EMBED_URL,
    iframeTitle = 'Merky FC 3D Hero Content'
}) {
    return (
        <CommonModal
            title={title}
            isOpen={isOpen}
            onClose={onClose}
            modalClassName='watch-video-modal'
            contentClassName='watch-video-modal-content'
        >
            <iframe className='watch-video-modal__iframe'
                src={embedUrl}
                title={iframeTitle}
                allow='autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media; web-share'
                referrerPolicy='strict-origin-when-cross-origin'
                allowFullScreen
            />
        </CommonModal>
    );
}


export default WatchVideoModal;